import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class LinkAccountService {
  private idamUrl: string = environment.idam_api_url + '/api/v1/';
  constructor(private http: HttpClient) { }

  acceptRequest(secret, response: string , tenant: string): Observable<HttpResponse<any>> {
    try{
      const url = `${this.idamUrl}confirmation/linked-account/${secret}/response?constraint=${response}&tenant=${tenant}`;
      return this.http.post<any>(url, { observe: 'response' });
    }
    catch(error) {
      throw error;
    }
  }
}
